import LayautContext from 'Context/ContextLayaut';
import { useContext } from 'react';

const ServiciosPlantilla = () => {
    const context = useContext(LayautContext);
    return {
        getPlantillasInt: context.llamarServidor('Plantilla/getPlantillasInt'),
        getPlantillasPorTipo: context.llamarServidor('Plantilla/getPlantillasPorTipo'),
        insertPlantilla: context.llamarServidorRespuesta('Plantilla/insertPlantilla'),
        updatePlantilla: context.llamarServidorRespuesta('Plantilla/updatePlantilla'),
        cambiarEstatusPlantilla: context.llamarServidorRespuesta('Plantilla/cambiarEstatusPlantilla'),
        getPreguntasPlantilla: context.llamarServidor('Plantilla/getPreguntasPlantilla'),
        insertPreguntaPlantilla: context.llamarServidorRespuesta('Plantilla/insertPreguntaPlantilla'),
        updatePreguntaPlantilla: context.llamarServidorRespuesta('Plantilla/updatePreguntaPlantilla'),
        cambiarEstatusPreguntaPlantilla: context.llamarServidorRespuesta('Plantilla/cambiarEstatusPreguntaPlantilla'),
        updateOrdenPreguntaPlantilla: context.llamarServidorRespuesta('Plantilla/updateOrdenPreguntaPlantilla')
    };
};

export default ServiciosPlantilla;
